import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the FilterRegisteredDocumentView.
 * @extends JetView
 */
export default class FilterRegisteredDocumentView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for Name
                            name: 'Name',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('Nombre'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for Type
                            name: 'Type',
                            id: 'Type',
                            minWidth: 200,
                            label: _('Tipo'), // Label for Type
                            labelPosition: 'top',
                            placeholder: _('Tipo'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for IsActivate
                            name: 'IsActivate',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: '',
                            options: [
                                // Options for IsActivate
                                { id: '0', value: _('Todos') },
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                        },
                        {
                            view: 'text', // Text input for Route
                            name: 'Route',
                            minWidth: 200,
                            label: _('Ruta'), // Label for Route
                            labelPosition: 'top',
                            placeholder: _('Ruta'), // Placeholder text
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };

        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to add document
                    value: _('Añadir Documento'),
                    type: 'form',
                    width: 200,
                    click: () => {
                        this.app.callEvent('addDocument:button', [{}]); // Event to add document
                    },
                },
                {
                    view: 'button', // Button to clear form
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to consult documents
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter data
                        this.app.callEvent('registeredDocument:filter', [
                            filterdata, // Trigger filter event
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };

        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Clear second form values
                    },
                },
                {
                    view: 'button', // Button to consult with second form
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter data from second form
                        this.app.callEvent('registeredDocument:filter', [
                            filterdata, // Trigger filter event
                        ]);
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };

        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };

        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup
                    {
                        view: 'icon', // Close icon for popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });

        return {
            view: 'form',
            id: 'myForm', // Main form ID
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            $$('Type').attachEvent('onItemClick', function (id, e) {
                // Event for Type dropdown
                webix
                    .ajax()
                    .headers({
                        'Content-type': 'application/json', // Set content type for AJAX request
                    })
                    .post(
                        devConfig.geturlApi() + 'RegisteredDocument/TypeDocument', // API endpoint
                        '',
                        {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var resp = JSON.parse(text); // Parse response
                                $$('Type').define('options', resp.Data); // Update options for Type dropdown
                                $$('Type').refresh(); // Refresh dropdown
                            },
                        },
                    );
            });
        });
    }
}

// FILE DOCUMENTED
